import { createSlice } from '@reduxjs/toolkit'

export const mapState = createSlice({
  name: 'mapState',
  initialState: {
    style: {
      type: {
        satellite: { id: 'satellite-v9', label: 'Imágenes' },
        light: { id: 'light-v10', label: 'Claro' },
        dark: { id: 'dark-v10', label: 'Oscuro' },
        streets: { id: 'streets-v11', label: 'Calles' },
        outdoors: { id: 'outdoors-v11', label: 'Al aire libre' },
      },
      current: 'satellite-v9',
    },
    popupOpen: false,
    currentTreeId: null,
    marker: {
      openMarker: false,
      draggable: false,
      lnglat: [],
    },
  },
  reducers: {
    changeMapStyle: (state, action) => {
      state.style.current = action.payload
    },
    changePopup: (state, action) => {
      state.popupOpen = action.payload
    },
    setCurrentTreeId: (state, action) => {
      state.currentTreeId = action.payload
    },
    setMarker: (state, action) => {
      state.marker = action.payload
    },
  },
})

export const { changeMapStyle, changePopup, setCurrentTreeId, setMarker } =
  mapState.actions
export default mapState.reducer
